import React from 'react'
import _ from 'lodash';
import PropTypes from 'prop-types';
import TransactionRow from 'modules/common/components/TransactionRow';

function PropertyLocation({ applicationInfo }) {

  return (
    <div className="row p-3">
      <div className="col-12 mt-1 ml-2">
        <span className="title-color">Owner</span>
      </div>
      <div className="col-12 mt-3">
        <table className="transaction-table table table-borderless table-sm table-striped">
          <tbody>
            <TransactionRow
              title="Name"
              value={_.get(applicationInfo, 'included.buildingOwner.attributes.full_name') || '--'}
            />
            <TransactionRow
              title="Telephone No."
              value={_.get(applicationInfo, 'included.buildingOwner.attributes.telephone_no') || '--'}
            />
            <TransactionRow
              title="Address"
              value={_.get(applicationInfo, 'included.buildingOwner.attributes.full_address') || '--'}
            />
            <TransactionRow
              title="TIN"
              value={_.get(applicationInfo, 'included.buildingOwner.attributes.tin') || '--'}
            />
          </tbody>
        </table>
      </div>
      <div className="col-12 mt-3 ml-2">
        <span className="title-color">Property Location</span>
      </div>
      <div className="col-12 mt-3">
        <table className="transaction-table table table-borderless table-sm table-striped">
          <tbody>
            <TransactionRow
              title="No./Street"
              value={_.get(applicationInfo, 'attributes.property_street') || '--'}
            />
            <TransactionRow
              title="Barangay"
              value={_.get(applicationInfo, 'attributes.property_barangay_name') || '--'}
            />
            <TransactionRow
              title="District"
              value={_.get(applicationInfo, 'attributes.property_district_name') || '--'}
            />
            <TransactionRow
              title="Province/City"
              value={_.get(applicationInfo, 'attributes.property_province_name') || '--'}
            />
          </tbody>
        </table>
      </div>
      <div className="col-12 mt-3 ml-2">
        <span className="title-color">Administrator Beneficial</span>
      </div>
      <div className="col-12 mt-3">
        <table className="transaction-table table table-borderless table-sm table-striped">
          <tbody>
            <TransactionRow
              title="User"
              value={_.get(applicationInfo, 'included.administratorBeneficialUser.attributes.full_name') || '--'}
            />
            <TransactionRow
              title="Telephone No."
              value={_.get(applicationInfo, 'included.administratorBeneficialUser.attributes.telephone_no') || '--'}
            />
            <TransactionRow
              title="Address"
              value={_.get(applicationInfo, 'included.administratorBeneficialUser.attributes.full_address') || '--'}
            />
            <TransactionRow
              title="TIN"
              value={_.get(applicationInfo, 'included.administratorBeneficialUser.attributes.tin') || '--'}
            />
          </tbody>
        </table>
      </div>
    </div>
  )
}

PropertyLocation.defaultProps = {
  applicationInfo: {}
};

PropertyLocation.propTypes = {
  applicationInfo: PropTypes.instanceOf(Object)
};

export default PropertyLocation
